/**
 * 系统用户接口列表
 */
import axios from '@/request/http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块

const order = {
    // 获取所有商品分类列表信息
    // 预售单列表
    getAllUserPresellOrder (params) {
        return axios.post('/order/mobileOrder/getAllUserPresellOrder', qs.stringify(params))
    },
    // 预售单详情
    getPresellOrderDetailBySheetNo (params) {
        return axios.post('/order/mobileOrder/getPresellOrderDetailBySheetNo', qs.stringify(params))
    },
    // 预售单作废
    updatePresellOrderCancelStatus (params) {
        return axios.post('/order/presell/updatePresellOrderCancelStatus', qs.stringify(params))
    },
    // 获取所有商品分类列表信息
    getUserAllOrderInfo (params) {
        return axios.post('/order/mobileOrder/getAllUserOrder', qs.stringify(params))
    },
    // 手机前台获取订单列表信息
    getAllUserOrderDock (params) {
        return axios.post('/order/mobileOrder/getAllUserOrderDock', qs.stringify(params))
    },
    //通过订单编号获取订单详情信息
    getOrderDetailBySheetNo (params) {
        return axios.post('/order/mobileOrder/getOrderDetailBySheetNo', qs.stringify(params))
    },
    //通过订单编号获取订单详情信息（对接新版）
    getOrderDetailInfoBySheetNoDock (params) {
        return axios.post('/order/mobileOrder/getOrderDetailInfoBySheetNoDock', qs.stringify(params))
    },
    //提交订单
    createOrder (params) {
        return axios.post('/order/reception_order/createOrder', qs.stringify(params))
    },
    //再来一单接口
    createAnotherOrder (params) {
        return axios.post('/order/reception_order/createAnotherOrder', qs.stringify(params))
    },
    //提交订单
    createOrderDock (params) {
        return axios.post('/order/reception_order/createOrder_dock', qs.stringify(params))
    },
    //提交订单（新版）
    createOrderDock1 (params) {
        return axios.post('/order/reception_order/createOrderDock1', params)
    },
    //再来一单接口
    createAnotherOrderDock (params) {
        return axios.post('/order/reception_order/createAnotherOrder_dock', qs.stringify(params))
    },
    //创建退货订单
    createRefundOrder (params) {
        return axios.post('/order/shopRefund/addRefundOrder', qs.stringify(params))
    },
    //创建退货订单
    createRefundOrderDock (params) {
        return axios.post('/order/shopRefund/addRefundOrder_dock', qs.stringify(params))
    },
    //查看用户退货单信息
    getAllRefundOrder (params) {
        return axios.post('/order/shopRefund/getAllRefundOrder', qs.stringify(params))
    },
    //获取退货单详情
    getAllRefundGoodsById (params) {
        return axios.post('/order/shopRefund/getAllRefundGoodsById', qs.stringify(params))
    },
    //获取退货单详情-独立版
    getAllRefundGoodsByIdAlone (params) {
        return axios.post('/order/mobileRefundOrderAlone/getAllRefundGoodsByIdAlone', qs.stringify(params))
    },
    //获取下单规则
    getRegionRule (params) {
        return axios.post('/order/orderRule/getOrderRule', qs.stringify(params))
    },
    //获取用户下单规则
    getOrderRule (params) {
        return axios.post('/order/reception_order/getOrderRule', qs.stringify(params))
    },
    //根据订单编号获取订单编号
    getOrderStatusBySheetNo (params) {
        return axios.post('/order/mobileOrder/getOrderStatusBySheetNo', qs.stringify(params))
    },
    //作废订单
    cancleOrderBySheetNo (params) {
        return axios.post('/order/mobileOrder/cancleOrderBySheetNo', qs.stringify(params))
    },
    //作废订单(新版)
    invaildOrderDock (params) {
        return axios.post('/order/mobileOrder/invaildOrderDock', qs.stringify(params))
    },
    //作废订单(不对接)
    cancleOrderBySheetNoNotDock (params) {
        return axios.post('/order/mobileOrder/cancleOrderBySheetNoNotDock', qs.stringify(params))
    },
    //取消订单信息接口
    delOrderBySheetNo (params) {
        return axios.post('/order/mobileOrder/delOrderBySheetNo', qs.stringify(params))
    },
    //再来一单接口（加入购物车）
    anotherAddBucketDock (params) {
        return axios.post('/order/reception_order/anotherAddBucket_dock', qs.stringify(params))
    },
    //获取配出单列表数据
    getAllocationOfCargoOrder (params) {
        return axios.post('/order/mobileOrder/getAllocationOfCargoOrder', qs.stringify(params))
    },
    //获取出库单详情数据
    getAllocationOrderDetail (params) {
        return axios.post('/order/mobileOrder/getAllocationOrderDetail', qs.stringify(params))
    },
    //确认收货
    confirmReceipt (params) {
        return axios.post('/order/backstage_order/confirmReceipt', qs.stringify(params))
    },
    //储值支付
    storedPayAllocationOrder (params) {
        return axios.post('/order/mobileOrder/storedPayAllocationOrder', qs.stringify(params))
    },
    checkStoredActivity (params) {
        return axios.post('/order/wzfPay/checkStoredActivity', qs.stringify(params))
    },
    // 根据折扣劵换算折扣金额
    getConversionOrderDiscountDock (params) {
        return axios.post('/order/reception_order/getConversionOrderDiscountDock', qs.stringify(params))
    },
    // 根据箱号获取批发单商品信息接口
    getWholesaleOrderChildByChestNo (params) {
        return axios.post('/order/mobileOrder/getWholesaleOrderChildByChestNo', qs.stringify(params))
    },
    // 获取手机验证码
    sendVerifyCode (params) {
        return axios.post('/order/userAlone/sendVerifyCode', qs.stringify(params))
    }
}

export default order


// WEBPACK FOOTER //
// ./src/request/api/order/order.js